// extracted by mini-css-extract-plugin
export default {"component":"pgg0o"};